<template>
  <yona-edit-dialog
    v-if="active"
    auto-open
    :display-name="displayName"
    v-bind="$attrs"
    v-on="$listeners"
    @close="deactivate"
  >
    <!-- eslint-disable-next-line vue/no-useless-template-attributes -->
    <template
      v-for="(_, name) in $slots"
      #[name]
    >
      <slot :name="name" />
    </template>
  </yona-edit-dialog>

  <div
    v-else
    class="lazy-yona-edit-dialog"
    @click="activate"
  >
    <span class="display-flex justify-center align-center">
      <span
        v-if="displayName || displayName === 0"
        class="lazy-yona-edit-dialog__display"
      >{{ displayName }}</span>

      <slot name="append-outer-display-name" />
    </span>
  </div>
</template>

<script>
import { ref } from '@vue/composition-api'
import YonaEditDialog from '@/views/components/util/YonaEditDialog.vue'

/**
 * YonaEditDialog の遅延マウント版(flyweightパターン)。
 * 通常時は表示値だけを素のテキストで描画し、クリックされた時にだけ
 * 本物の YonaEditDialog をマウントして自動で開く。
 * v-data-table の行×列ぶん v-edit-dialog(v-menu + v-text-field)が
 * 常駐して描画が重くなるのを防ぐ。
 * props/イベント/スロットは YonaEditDialog へそのまま透過する。
 */
export default {
  components: {
    YonaEditDialog,
  },
  inheritAttrs: false,
  props: {
    displayName: {
      type: [String, Number],
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const active = ref(false)

    const activate = () => {
      if (props.disabled) return

      active.value = true
    }

    const deactivate = () => {
      active.value = false
    }

    return {
      active,
      activate,
      deactivate,
    }
  },
}
</script>

<style lang="scss" scoped>
.lazy-yona-edit-dialog {
  cursor: pointer;
  /* 表示値もスロット内容も空のセルで高さが0になり、クリックで編集ダイアログを
     開けなくなるのを防ぐ(最低限のクリック領域を確保する) */
  display: flex;
  align-items: center;
  min-height: 32px;

  .lazy-yona-edit-dialog__display {
    border-bottom: 1px dashed rgba(140, 140, 140, 0.5);
  }
}
</style>
